<script lang="ts">
  import MediaQuery from '../components/MediaQuery.svelte'
  import Masonry from '../components/Masonry.svelte'
  import BillCard from './BillCard.svelte'
  import MakerCard from './MakerCard.svelte'

  import { BILLS_TYPE } from '../const'

  export let items: array
  export let type: string

  const isBills = type === BILLS_TYPE
</script>

<div class="catalog-container">
  <MediaQuery query="(max-width: 320px)" let:matches>
    {#if matches}
      <Masonry
        gridGap={'20px'}
        colWidth={'70vw'}
        items={items}
      >
        {#each items as card, index (index)}
          {#if isBills}
            <BillCard card={card} />
          {:else}
            <MakerCard card={card} />
          {/if}
        {/each}
      </Masonry>
    {/if}
  </MediaQuery>

  <MediaQuery query="(min-width: 321px) and (max-width: 570px)" let:matches>
    {#if matches}
      <Masonry
        gridGap={'12px'}
        colWidth={'48%'}
        items={items}
      >
        {#each items as card, index (index)}
          {#if isBills}
            <BillCard card={card} />
          {:else}
            <MakerCard card={card} />
          {/if}
        {/each}
      </Masonry>
    {/if}
  </MediaQuery>

  <MediaQuery query="(min-width: 571px)" let:matches>
    {#if matches}
      <Masonry
        gridGap={'12px'}
        colWidth={'32%'}
        items={items}
      >
        {#each items as card, index (index)}
          {#if isBills}
            <BillCard card={card} />
          {:else}
            <MakerCard card={card} />
          {/if}
        {/each}
      </Masonry>
    {/if}
  </MediaQuery>
</div>

<style>
  .catalog-container {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  @media screen and (min-width: 32rem) {
    .catalog-container {
      display: block;
    }
  }
</style>
